import { apiHelper } from '@/util'
import { SHARED } from '@/constants/constants'
import axios from 'axios'

export const gameService = {
         getGames,
         getProviderTypeConfig,
         launchGame,
         gameCategories,
         getGameListVersion,
         getJackpot,
         getPlayerGameDetails,
         quickRegister,
         kisskayadeeplink,
         matchesHighlights,
         getHomepageHot,
         getTournamentGames,
         getBhaggoGames
       }

//API URLs
const GAME = {
  GAME: 'game',
  TYPES: 'types',
  CATEGORIES: 'categories',
  PLAYER_DETAILS: 'playerdetails',
  MEDIA_SERVER_URL: SHARED.MEDIA_SERVER_URL,
  SERVER_NAME: SHARED.SERVER_NAME,
  JACKPOT_URL: 'json/BABU88/grand_jackpot.json',
  LIST_VERSION: 'gameListVersion',
  QUICK_REGISTER: 'quickregister',
  DEEPLINK: 'kisskaya/deeplink',
  HOMEPAGE_HOT: 'homepagehot',
  TOURNAMENT_GAME: 'tournamentGames',
  BHAGGO_GAME: 'hpBhgGames'
}

function kisskayadeeplink(data) {
  const requestBody = {
    provider: data.provider
  }
  return apiHelper().post(`/${GAME.GAME}/${GAME.DEEPLINK}`, requestBody)
}

function quickRegister(data) {
  const requestBody = {
    provider: data.provider
  }
  return apiHelper().post(`/${GAME.GAME}/${GAME.QUICK_REGISTER}`, requestBody)
}

function getPlayerGameDetails(data) {
  let requestBody = {
    params: {
      provider: data.provider
    }
  }
  return apiHelper().get(`/${GAME.GAME}/${GAME.PLAYER_DETAILS}`, requestBody)
}

function getGames(data) {
  const { currency, type, platform } = data
  const brandName = SHARED.BRAND_OFFICIAL_NAME_ENV.toLowerCase()
  const serverName = SHARED.SERVER_NAME.toLowerCase()
  const path = `products/${brandName}/${serverName}/${currency.toLowerCase()}/${platform.toLowerCase()}/${type.toLowerCase()}`

  const res = axios
    .get(`${SHARED.MEDIA_DOMAIN}/${path}/games.json`)
    .then(response => {
      return {
        success: true,
        code: 0,
        data: {
          meta: response.data.meta,
          data: response.data.data
        }
      }
    })
    .catch(error => {
      return {
        success: false,
        code: error.response?.status || 500,
        error: error.message || 'Failed to fetch games'
      }
    })
  return res
}

function getGameListVersion(data) {
  const requestBody = {
    params: {
      currency: data.currency,
      platform: data.platform,
      game_type: data.game_type
    }
  }

  return apiHelper().get(`/${GAME.GAME}/${GAME.LIST_VERSION}`, requestBody)
}

function getHomepageHot(data) {
  let requestBody = {
    params: {
      currency: data.currency,
      size: data.size,
      page: data.page,
      platform: data.platform,
      mode: data.mode
    }
  }
  return apiHelper().get(`/${GAME.GAME}/${GAME.HOMEPAGE_HOT}`, requestBody)
}

function getTournamentGames(data) {
  let requestBody = {
    params: {
      currency: data.currency,
      size: data.size,
      page: data.page,
      platform: data.platform,
      mode: data.mode
    }
  }
  return apiHelper().get(`/${GAME.GAME}/${GAME.TOURNAMENT_GAME}`, requestBody)
}

function getBhaggoGames(data) {
  let requestBody = {
    params: {
      currency: data.currency,
      size: data.size,
      page: data.page,
      platform: data.platform,
      mode: data.mode
    }
  }
  return apiHelper().get(`/${GAME.GAME}/${GAME.BHAGGO_GAME}`, requestBody)
}

function getProviderTypeConfig(obj) {
  const requestOptions = {
    params: {
      currency: obj.currency,
      platform: obj.platform
    }
  }
  return apiHelper().get(`/${GAME.GAME}/${GAME.TYPES}`, requestOptions)
}

function launchGame(gameObj) {
  const requestBody = {
    provider: gameObj.provider,
    game_id: gameObj.gameId,
    game_code: gameObj.gameCode,
    is_demo: gameObj.isDemo,
    platform: gameObj.platform,
    language: gameObj.language,
    website: gameObj.webSite,
    currency: gameObj.currency,
    game_type: gameObj.gameType
  }
  return apiHelper().post(`/${GAME.GAME}`, requestBody)
}

function gameCategories() {
  return apiHelper().get(`/${GAME.GAME}/${GAME.CATEGORIES}`)
}

function getJackpot() {
  return apiHelper(`${GAME.MEDIA_SERVER_URL}`, false).get(`/${GAME.JACKPOT_URL}`)
}

function matchesHighlights() {
  return apiHelper(`${GAME.MEDIA_SERVER_URL}/${GAME.SERVER_NAME}`, false).get(`/cricket/data_${SHARED.DEFAULT_CURRENCY}.json`)
}
